module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4.7 13.2L15 21.7v-5.3h7.7c1.4 0 2.5-1.3 2.5-2.9V13c0-1.6-1.1-2.9-2.5-2.9H15V4.6L4.7 13.2z","fill":"#bf0049"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/undo.svg
// module id = 727
// module chunks = 2